
<template>
  <div v-if="mode">
    <md-content >
      <div :class="layout" >


        <div v-if="saveData.teaser" @_click.stop="setView"
              :style="{backgroundImage: 'url(' + (saveData.teaser && saveData.teaser.url ? (saveData.teaser.url + '?t=' + saveData.teaser.time) : saveData.teaser) + ')'}" class="fb-teaser">
          <md-button
          @click.stop="setView"
          class="md-primary fb-play-button md-icon-button md-accent md-raised"
        >
          <md-icon :md-src="require('@/assets/play.svg')"></md-icon>
        </md-button>
        <div class="time" v-if="saveData.time">{{ saveData.time }}</div>
        </div>

        <div v-else @_click.stop="setView" class="fb-teaser">
          <md-button
                  @click.stop="setView"
                  class="md-primary fb-play-button md-icon-button md-accent md-raised"
          >
            <md-icon :md-src="require('@/assets/play.svg')"></md-icon>
          </md-button>
          <div class="time" v-if="saveData.time">{{ saveData.time }}</div>
        </div>


        <div class="fb-info-section">
          <div class="fb-info-label">{{ saveData.label | token_replace(nid)}}</div>
          <div class="fb-info-desc">{{ saveData.description | token_replace(nid)}}</div>
        </div>
      </div>
    </md-content>

    <md-dialog v-if="saveData.inDialog" :class="contentTypeClass" :md-active.sync="showContent" md-dynamic-height>
      <md-dialog-title>
        {{ saveData.label | token_replace(nid) }}
        <md-button class="md-icon-button fb-close" @click="showContent=false">
          <md-icon>close</md-icon>
        </md-button>
      </md-dialog-title>
      <md-dialog-content>
        <fb-info-view :nid="nid" :sid="sid" :validate="validate" :step="step" :active="active" :element="{data: saveData}" :mode="true" />
      </md-dialog-content>
    </md-dialog>
  </div>
  <md-card v-else class="md-elevation-2 md-layout-item">
    <fb-controll
      :controll="saveData.label || 'InfoButtonTeaser'"
      @collapse-click="collapsePreview"
      @setting-click="showSettings"
      @menu-delete="$emit('menu-delete')"
    />
    <md-content v-show="!collapse">
      <div :class="layout">
        <div :style="{backgroundImage: 'url(' + (saveData.teaser && saveData.teaser.url ? (saveData.teaser.url + '?t=' + saveData.teaser.time) : saveData.teaser) + ')'}" class="fb-teaser">
          <md-button
          @click="setView"
          class="md-primary fb-play-button md-icon-button md-accent md-raised"
        >
          <md-icon>play_arrow</md-icon>
          </md-button>
          <div class="time" v-if="saveData.time">{{ saveData.time }}</div>
        </div>


        <div class="fb-info-section">
          <div class="fb-info-label">{{ saveData.label | token_replace(nid)}}</div>
          <div class="fb-info-desc">{{ saveData.description | token_replace(nid)}}</div>
        </div>
      </div>

    </md-content>
    <md-dialog :md-active.sync="showDialog" md-dynamic-height>
      <md-dialog-title>Settings</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Label</label>
          <md-input v-model="tempData.label"></md-input>
        </md-field>
        <md-checkbox v-model="tempData.inDialog">Show in dialog</md-checkbox>
        <md-field>
          <label>Time</label>
          <md-input v-model="tempData.time"></md-input>
        </md-field>
        <md-field>
          <label>Description</label>
          <md-input v-model="tempData.description"></md-input>
        </md-field>
        <md-field class="fb-select">
          <label for="type">layout</label>
          <md-select v-model="tempData.type" name="type">
            <md-option value="full-width">Full width</md-option>
            <md-option value="side-width">Side view</md-option>
          </md-select>
        </md-field>

        <div class="text-left">
          <img class="teaser-preview" width="300" v-if="tempData.teaser" :src="tempData.teaser && tempData.teaser.url ? (tempData.teaser.url + '?t=' + saveData.teaser.time) : tempData.teaser" />
          <md-button @click="openPicker" class="md-primary">Upload Teaser</md-button>
          <input style="display:none" type="file" ref="inputFile" @change="onFileChange" />
        </div>
        <div class="md-layout">
          <div class="md-layout-item fb-section">
            <div class="full-height">
              <draggable
                class="dragAreaInline dragAreaInline-bottom show-draggable full-height"
                tag="div"
                :list="tempData.value"
                group="controls"
              >
                <component
                  v-for="(element, index) in tempData.value"
                  @save-data="updateData(index, $event)"
                  @menu-delete="removeItem(index)"
                  :uuid="element.uuid"
                  :key="element.uuid"
                  :is="element.type"
                  :element="element"
                  :mode="0"
                  :validate="validate"
                ></component>
              </draggable>
            </div>
          </div>
          <div class="md-layout-item md-size-30 md-small-size-50 fb-controll-section">
            <div class="sticky-wrapper sticky-wrapper-inline" _v-sticky sticky-offset="offset" sticky-side="top">
              <draggable v-model="controls" class="dragAreaControll" v-bind="getOptions()">
                <md-list
                  v-for="(element, index) in controls"
                  :key="index"
                  class="fb-controll-section"
                >
                  <fb-delimiter v-if="element.type == 'FbDelimiter'"></fb-delimiter>
                  <md-list-item v-else class="md-elevation-2">
                    <md-icon>{{element.icon}}</md-icon>
                    <span class="md-list-item-text">{{element.label}}</span>
                  </md-list-item>
                </md-list>
              </draggable>
            </div>
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cancel">Close</md-button>
        <md-button class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import FbElementMixin from "../FbElementMixin";
import draggable from "vuedraggable";

export default {
  name: "FbInfoButtonTeaser",
  props: ["element", "mode", "validate", "step", "active"],
  mixins: [FbElementMixin],

  components: {
    draggable,
  },
  created() {
    if (this.$route && this.$route.params && this.$route.params.component) {
      this.showContent = true;
    }
  },
  computed: {
    contentTypeClass() {
      if (this.saveData.value.length == 1) {
        return this.saveData.value[0].type == "FbHtmlPackage" ? 'without-background' : '';
      }
    },
    layout() {
      return {
        "md-content md-button md-primary fb-info-button md-raised md-theme-default side-width":
          this.saveData.type == "side-width",
        "full-width": this.saveData.type == "full-width"
      };
    }
  },
  data() {
    return {
      showContent: false,
      controls: [
        // {
        //   type: "FbParagraph",
        //   label: "Paragraph",
        //   icon: "subject",
        //   list: [],
        //   data: {
        //     label: "Paragraph",
        //     value: "Paragraph"
        //   }
        // },
        {
          type: "FbHtmlPackage",
          label: "H5P",
          icon: "extension",
          list: [],
          data: {
            label: "H5P",
            value: ""
          }
        },
        // {
        //   type: "FbQuiz",
        //   label: "Quiz",
        //   icon: "quiz",
        //   list: [],
        //   data: {
        //     label: "Quiz",
        //     value: ""
        //   }
        // },
        // {
        //   type: "FbScorm",
        //   label: "Scorm",
        //   icon: "quiz",
        //   list: [],
        //   data: {
        //     label: "Scorm",
        //     value: ""
        //   }
        // },
      ],
      tempData: {
        type: this.element.data.type || "full-width",
        label: this.element.data.label || "",
        time: this.element.data.time || "",
        value: this.element.data.value || [],
        teaser: this.element.data.teaser || "",
        description: this.element.data.description || "",
        inDialog: this.element.data.inDialog || false,
        required: this.element.data.required || false
      },
      saveData: {
        type: this.element.data.type || "full-width",
        label: this.element.data.label || "",
        time: this.element.data.time || "",
        value: this.element.data.value || [],
        teaser: this.element.data.teaser || "",
        description: this.element.data.description || "",
        inDialog: this.element.data.inDialog || false,
        required: this.element.data.required || false
      }
    };
  },
  methods: {
    readFile(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.addEventListener("loadend", function(e) {
          // reader.result contains the contents of blob as a typed array
          if (!e.target.result) {
            reject();
          }
          resolve(e.target.result);
        });
        if (file != "") {
          reader.readAsDataURL(file);
        } else {
          reject();
        }
      });
    },
    onFileChange(event) {
      this.readFile(event.target.files[0]).then(buffer => {
        this.tempData.teaser = buffer;
      });
    },
    openPicker() {
      this.$refs.inputFile.value = "";
      this.$refs.inputFile.click();
    },
    setView() {
      if (this.saveData.inDialog) {
        this.showContent = true;
        return;
      }
      let path = this.$route.path + "/" + this.element.uuid;
      this.$router.push({ path });
    },
    getOptions() {
      return {
        group: {
          name: "controls",
          pull: "clone",
          put: false
        },
        sort: false,
        clone: this.clone,
        move: this.move
      };
    },
    removeItem(index) {
      this.tempData.value.splice(index, 1);
    },
    updateData(index, event) {
      this.tempData.value[index].data = event.data;
      this.tempData.value[index].list = event.list;
    }
  }
};
</script>


<style lang="scss" scoped>
.teaser-preview {
  display: block;
  margin-bottom: 20px;
  border: 1px solid #c9c9c9;
}
.full-width {

  margin-top: -2px;


  background-size: cover;
  .fb-teaser {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    color: #ffffff;
    margin-left: -16px;
    margin-right: -16px;
    min-height: 189px;
    position: relative;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-size: 100% auto;
    background-position: center center;
    background-repeat: no-repeat;
    transition: $transition;
    &:hover {
      background-size: 110% auto;
    }
    &::before {
      position: absolute;
      background-color: rgba(0, 0, 0, 0.5);
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: block;
      content: "";
    }
  }
  .fb-play-button {
    height: 43px;
    width: 43px;
    background-color: #FA7766 !important;
    &:hover {
      &:before {
        background-color: #000;
        opacity: .1;
      }
    }
  }
  .time {
    position: absolute;
    left: 15px;
    bottom: 0;
    background-color: #FA7766;
    color: #fff;
    opacity: .8;
    font-size: 12px;
    line-height: 18px;
    padding: 1px 8px;
  }

  .fb-info-section {
    padding: 16px;
    // position: absolute;
    // left: 0;
    // bottom: 0;
    // right: 0;
    text-align: left;

    .fb-info-label {
      color: rgb(60, 60, 60);
      font-family: "filson-soft",sans-serif;;
      font-size: 16px;
      font-weight: bold;
      height: 24px;
      line-height: 24px;
      @media all and (min-width: $breakpoint-medium) {
        font-size: 20px;
      }
    }
    .fb-info-desc {
      color: rgb(60, 60, 60);
      font-size: 14px;
    }
  }
}

.side-width {
  height: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  background-size: cover;
  .fb-teaser {
    position: absolute;
    left: 0;
    top: 0;
    width: 100px;
    height: 100%;
    background-size: cover;
    &::before {
      position: absolute;
      background-color: rgba(0, 0, 0, 0.5);
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: block;
      content: "";
    }
  }
  .fb-play-button {
    position: absolute;
    left: 25px;
    top: 50%;
    margin-top: -22px;

    height: 20px;
    width: 20px;
    background-color: #FA7766;

  }

  .fb-info-section {
    padding: 8px;
    margin-left: 100px;
    text-align: left;

    .fb-info-label {
      font-size: 18px;
    }
    .fb-info-desc {
      font-size: 14px;
    }
  }
}

.md-button.fb-info-button {
  width: 100%;
}

.fb-close {
  position: absolute;
  top: 6px;
  right: 0px;
}

.md-dialog {
  min-width: 60%;
  &.without-background {
    border-radius: 0px;
    background: none !important;
    box-shadow: none;
    max-height: 800px;

    @media (orientation: portrait) and (max-width: $breakpoint-medium) {
        margin-top: -190px;
    }
    @media all and (max-width: $breakpoint-medium) {
      top: 50%;
      overflow: visible;
      z-index: 999;
    }

    .md-dialog-title.md-title {
      color: transparent;
      position: absolute;
      top: 0px;
      right: 0px;
      .fb-close {
        top: 0px;
        .md-icon-font {
          color: #777;
        }
      }
    }
    .md-dialog-content {
      padding: 0px;
      margin-top: 45px;
      position: relative;
    }
  }
}
.md-dialog-content::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}
.md-dialog-content::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  background-position: center center;
}
</style>

<style lang="scss">
.dragAreaInline {
  &::before {
    margin-top: 0;
  }
}
.dragAreaControll {
  padding: 5px;
}
.sticky-wrapper-inline {
  top: 0;
}
</style>
